<template>
  <div class='newMarkLineItem'>
    <div class="left-content-box">
       <div class="markLeftItem">
        <div class="left-box">
          <el-tooltip class="item" effect="light" :content="item.title" placement="bottom" >
            <div class="left-content">{{item.title}}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
     <div class="content-box">
        <MarkItem v-for="(model, index) in modelList" :class="index == 0 ? 'item-1': 'item-w'" :key="model" :model="model" :isShowThree="isShowThree" @click="selectMark(model)"></MarkItem>
     </div>
  </div>
</template>
<script>
import MarkItem from "@/components/MarkItem.vue";
export default {
  name: 'newMarkLineItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isShowThree: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    modelList() {
      const list = []
      for (const m of this.item.modelList) {
        if (!m?.isHidden) {
          list.push(m)
        }
      }
      return list
    }
  },
  created() {
    
  },
  components: {
    MarkItem,
  },
}
</script>
<style lang='less' scoped>

.newMarkLineItem {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  background-color: #fff;
}

.left-content-box {
  width: 444px;
  background-color: #f6f6f6;
  display: flex;
  padding-top: 20px;
  
}

.markLeftItem {
  display: flex;
  flex-direction: row;
  width: 444px;
  justify-content: flex-end;
}

.left-box {
  background-color: #f6f6f6;
  display: flex;
  max-width: 400px;
  padding: 0px 20px 0px 20px;
  height: 60px;
  color: #707070;
  font-size: 18px;
  border-width: 0.5px;
  border-style: solid;
  border-color: #707070;
  align-items: center;
  margin-right: 10px;
  background-color: #fff;
  cursor: pointer;
}

.left-content {
  white-space: nowrap; 
  overflow: hidden;
  text-overflow:ellipsis;
}

.content-box {
  display: flex;
  flex-direction: row;
  padding-top: 20px;

  .item-1 {
    margin-left: 10px;
  }

  .item-w {
    margin-left: 20px;
  }
}

</style>